<template>
  <StrokeButton :loading="isLoading" size="mini" @click="getInvoice">
    {{ $t('ADVERTISEMENT.TRANSACTIONS.DOWNLOAD_INVOICE_FACTOR') }}
  </StrokeButton>
</template>

<script>
import FileSaver from 'file-saver';
import { AdFinance } from '@/api/api';

import StrokeButton from '../../../common/StrokeButton';

export default {
  name: 'TransactionsTableInvoiceColumnContent',
  components: {
    StrokeButton,
  },
  props: {
    invoiceTag: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      isLoading: false,
    };
  },
  methods: {
    getInvoice() {
      this.isLoading = true;
      return AdFinance.downloadTransactionInvoiceFactor(this.invoiceTag)
        .then(blob => {
          FileSaver.saveAs(
            blob,
            `cafebazaar-advertisement-invoice-${this.invoiceTag}.pdf`,
          );

          this.$message.success(
            this.$t('ADVERTISEMENT.TRANSACTIONS.DOWNLOAD_FACTOR_SUCCESSFUL'),
          );
        })
        .catch(({ message }) => {
          this.$message.error(message);
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
  },
};
</script>
